import React from "react";

import Sheldon from "@common/assets/images/ai/sheldon.png";
import Sparkle from "@common/assets/images/ticket-icons/sparkle-icon.png";
import { vars } from "@common/styles";
import * as Styled from "@main/pages/Administration/components/TeamMembersCard/TeamMemberRows/TeamMemberRow.styles";

export const TeamMemberAiAgentRow = () => {
  return (
    <Styled.Row>
      <div style={{ display: "flex", flex: 2, alignItems: "center" }}>
        <Styled.Avatar
          src={Sheldon}
          alt={"Sheldon avatar"}
          style={{ marginRight: "0.8rem" }}
        />
        <Styled.AiName style={{ marginRight: "0.4rem" }}> {"Sheldon"}</Styled.AiName>
        <img
          src={Sparkle}
          alt="AI Sparkle"
          style={{ verticalAlign: "bottom", marginLeft: "0.4rem" }}
        />
      </div>

      <div style={{ display: "flex", flex: 1, alignItems: "center" }}>
        <Styled.RowTag
          color={"linear-gradient(180deg, #B77DFF 0%, #EB5757 100%)"}
          value={"triaging assistant"}
          border
          borderColor={vars.colors.grey90}
        />
      </div>

      <div style={{ display: "flex", flexBasis: "10rem", alignItems: "center", justifyContent: "end" }}></div>
    </Styled.Row>
  );
};
